export { IsArchiveFilePipe } from './lib/pipe/is-archive-file.pipe';
export { IsArchiveFileWithNotPurePipe } from './lib/pipe/is-archive-file-with-not-pure.pipe';
export { IsAudioFilePipe } from './lib/pipe/is-audio-file.pipe';
export { IsAudioFileWithNotPurePipe } from './lib/pipe/is-audio-file-with-not-pure.pipe';
export { IsDocumentFilePipe } from './lib/pipe/is-document-file.pipe';
export { IsDocumentFileWithNotPurePipe } from './lib/pipe/is-document-file-with-not-pure.pipe';
export { IsImageFilePipe } from './lib/pipe/is-image-file.pipe';
export { IsImageFileWithNotPurePipe } from './lib/pipe/is-image-file-with-not-pure.pipe';
export { IsTextFilePipe } from './lib/pipe/is-text-file.pipe';
export { IsTextFileWithNotPurePipe } from './lib/pipe/is-text-file-with-not-pure.pipe';
export { IsVideoFilePipe } from './lib/pipe/is-video-file.pipe';
export { IsVideoFileWithNotPurePipe } from './lib/pipe/is-video-file-with-not-pure.pipe';
export {
  type MimeTypes,
  MIME_EXTENSION_MAP,
  isArchiveFile,
  isApplication7zCompressedFile,
  isApplicationExcelSheetFile,
  isApplicationGzipFile,
  isApplicationJsonFile,
  isApplicationMsExcelFile,
  isApplicationMsPowerpointFile,
  isApplicationPowerpointPresentationFile,
  isApplicationRarCompressedFile,
  isApplicationMswordFile,
  isApplicationPdfFile,
  isApplicationTarFile,
  isApplicationWordDocumentFile,
  isApplicationXmlFile,
  isApplicationZipFile,
  isAudioFile,
  isVideoFile,
  isDocumentFile,
  isTextFile,
  isImageFile,
  isAudioAacFile,
  isAudioFlacFile,
  isAudioMpegFile,
  isAudioOggFile,
  isAudioWavFile,
  isImageBmpFile,
  isImageGifFile,
  isImageJpegFile,
  isImagePngFile,
  isImageSvgXmlFile,
  isImageTiffFile,
  isImageWebpFile,
  isTextCssFile,
  isTextCsvFile,
  isTextHtmlFile,
  isTextJavascriptFile,
  isTextPlainFile,
  isVideoAviFile,
  isVideoMp4File,
  isVideoMkvFile,
  isVideoMovFile,
  isVideoWebmFile,
  isVideoWmvFile,
} from './lib/mime-type';
